module.exports = __webpack_public_path__ + "fdf3413fd4c475848614fce9f71b195c.png";